import { apply, call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';
import { getDataTimeString } from '../../../libs/Util';
import Auth from '../../../libs/Auth';
import config from '../../../../../config';
import history from "../../../history";

export function* fetchPayments(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/payments/list', {
    query: {
      page: payload.page,
      filters: JSON.stringify(payload.filters),
      sort: payload.filters.sort,
    }
  });
  yield put({
    // $global: true,
    type: 'SET_PAYMENTS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}
export function* fetchCrossCheckPayments(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const regex = /claim code xxxx-xxxxxx-([A-z0-9]{4})\)\t\$([0-9.]+)/gi;
  const amazonCodes = [];
  const amazonCodesMap = {};
  let match;
  while (match = regex.exec(payload.data.amazonGiftcardsText)) {
    const amazonCode = {
      code: match[1],
      value: parseFloat(match[2]),
    };
    amazonCodes.push(amazonCode);
    amazonCodesMap[amazonCode.code] = amazonCode;
  }
  const data = yield call(Http.get, '/payments/list', {
    query: {
      page: 1,
      filters: JSON.stringify({
        type: 'Amazon Gift Card',
        codes: amazonCodes.map(item => item.code + '$'),
      }),
      sort: '_id',
    }
  });

  const foundPayments = {};
  const payments = data.payments.map(payment => {
    const codePrefix = payment.code.substr(-4);
    foundPayments[codePrefix] = payment;
    return {
      ...payment,
      amazonCode: amazonCodesMap[codePrefix],
    };
  });
  const missingCodes = amazonCodes.filter((amazonCode) => {
    return !foundPayments[amazonCode.code];
  });
  yield put({
    // $global: true,
    type: 'SET_CROSS_CHECK_PAYMENTS',
    payload: {
      payments,
      missingCodes,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* exportPaymentsCSV(action) {
  const { payload, meta } = action;


  yield put({ $global: true, type: 'START_LOADER' });

  const currentDate = getDataTimeString();
  const filename = `${currentDate} - ${payload.filters.type} - ${payload.exportType} - export.csv`;

  yield call(Http.get, '/payments/exportCSV', {
    query: {
      exportType: payload.exportType,
      filters: JSON.stringify(payload.filters),
      filename: filename,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
  yield apply(history, history.push, ['/workArea/files']);
}

export function* updatePaymentDetails(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.post, '/payments/update', {
    body: {
      _id: payload._id,
      data: payload.data,
    }
  });
  yield fetchPayments(action);
  yield put({ type: 'PAYMENT_UPDATED', payload });
  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* createPayment(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const results = yield call(Http.post, '/payments/create', {
    body: {
      data: payload.data,
    }
  });

  if (results.filteredPayments && results.filteredPayments.length) {
    yield put({
      $global: true,
      type: 'ERROR',
      error: true,
      payload: {
        message: `The following codes already exist so were not added ${results.filteredPayments.map(item => item.code).join(',')}`,
      }
    });
  }

  yield put({
    type: 'FETCH_PAYMENTS',
    payload: {
      filters: payload.filters,
      page: payload.page,
    }
  });

  yield put({
    type: 'TOGGLE_MODAL',
    payload: {
      active: false,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* fetchOffers(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/offers/offers', {
    query: {}
  });
  yield put({
    // $global: true,
    type: 'SET_OFFERS_FOR_PAYMENTS',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst }) {
  yield [
    takeFirst('FETCH_OFFERS_FOR_PAYMENTS', fetchOffers),
    takeFirst('FETCH_CROSS_CHECK_PAYMENTS', fetchCrossCheckPayments),
    takeFirst('FETCH_PAYMENTS', fetchPayments),
    takeFirst('EXPORT_PAYMENTS_CSV', exportPaymentsCSV),
    takeFirst('UPDATE_PAYMENT_DETAILS', updatePaymentDetails),
    takeFirst('CREATE_PAYMENT', createPayment),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/Payments.sagas.js